import { atom } from 'jotai';

export const allowDeleteAtom = atom(false);